import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { httpInterceptorInterceptor } from './core/interceptor/http-interceptor.intercepto';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UnauthorizedInterceptor } from './core/interceptor/unauthorized.interceptor';
import { NgIdleModule } from '@ng-idle/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    importProvidersFrom(
      BrowserModule,
      HttpClientModule,
      RouterModule,
      AppRoutingModule,
      BrowserAnimationsModule,
      NgIdleModule.forRoot(),
    ),
    provideHttpClient(withInterceptors([httpInterceptorInterceptor])),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true,
    },
  ],
};
